import { z } from "zod";

const approveVideoSchema = z.object({
  videos: z.array(
    z.object({
      id: z.string(),
      title: z
        .string({ required_error: "A title is required" })
        .min(1, "A title is required")
        .max(30, "The title should be at most 30 characters"),
      summary: z
        .string({ required_error: "A summary is required" })
        .min(1, "A summary is required")
        .max(100, "The summary should be at most 100 characters"),
      showOnProfile: z.boolean(),
    }),
  ),
});

const uploadVideoSchema = z.object({
  video: z.instanceof(File, {
    message: "A video is required",
  }),
  title: z
    .string({ required_error: "A title is required" })
    .min(1, "A title is required")
    .max(30, "The title should be at most 30 characters"),
  summary: z
    .string({ required_error: "A summary is required" })
    .min(1, "A summary is required")
    .max(100, "The summary should be at most 100 characters"),
});

type ApproveVideoSchema = z.infer<typeof approveVideoSchema>;
type UploadVideoSchema = z.infer<typeof uploadVideoSchema>;

export {
  approveVideoSchema,
  uploadVideoSchema,
  type ApproveVideoSchema,
  type UploadVideoSchema,
};
